export default "__VITE_ASSET__C7ooBXM8__"